
<section id="main-henterpant">
  <a id="home" class="anchor"></a>
  <div class="container">
    <div class="row align-items-center">

      <!-- Left Block -->
      <div class="col-md-6 text-white main-henterpant-text">
        <h1 class="title">{{ 'HOME.HENTERPANT.TITLE' | translate }}</h1>
        <p class="description">{{ 'HOME.HENTERPANT.DESCRIPTION' | translate }}</p>
        <button class="btn btn-primary-henterpant" (click)="goToSignUp()">
          {{ 'HOME.HENTERPANT.SIGN_UP' | translate }}
        </button>
        <div class="buttons-wrap">
          <a [href]="storeLinks.HENTERPANT.appStore" class="store-btn apple" target="_blank"></a>
          <a [href]="storeLinks.HENTERPANT.googlePlay" class="store-btn android" target="_blank"></a>
        </div>
      </div>

      <!-- Right Block: Custom App Screens Carousel -->
      <div class="col-md-6">
        <div class="custom-carousel d-flex justify-content-center align-items-center">
          <div
            *ngFor="let screen of screens; let i = index"
            class="carousel-item-custom"
            [class.active]="i === currentIndex"
            [class.left]="i === (currentIndex - 1 + screens.length) % screens.length"
            [class.right]="i === (currentIndex + 1) % screens.length"
          >
            <img ngSrc="{{screen.src}}" width="250" height="492" loading="lazy" class="rounded" [alt]="screen.alt">
            <div class="tip-overlay" *ngIf="i === currentIndex">
              <div class="icon-wrap">
                <i class="icon {{screen.icon}}"></i>
              </div>
              <div class="tip-content">
                <span><i>{{ (screen.player ? 'HOME.HENTERPANT.PROFILE.PLAYER' : 'HOME.HENTERPANT.PROFILE.TEAM') | translate}}</i></span>
                {{screen.tip}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>




<section id="how-works">
  <a id="how-it-works" class="anchor"></a>
  <div class="container">
    <app-how-works [henterPantMode]="true"></app-how-works>
  </div>
</section>


<section id="features-player">
  <a id="features" class="anchor"></a>
  <div class="container">
    <app-features [henterPantMode]="true" [playerMode]="true"></app-features>
  </div>
</section>

<section id="features-team">
  <div class="container">
    <app-features [henterPantMode]="true" [teamMode]="true"></app-features>
  </div>
</section>

<section id="become-member">
  <div class="container">
    <div class="description">
      <h2 class="title" [innerHTML]="'MEMBER.TITLE' | translate"></h2>
      <p class="description">{{'MEMBER.DESCRIPTION' | translate}}</p>
    </div>
    <div class="button-wrap">
      <button class="btn btn-primary-henterpant" (click)="goToSignUp()">{{'MEMBER.BUTTON' | translate}}</button>
    </div>
  </div>
</section>

<section id="reviews">
  <a id="about-us" class="anchor"></a>
  <div class="container">
    <app-reviews [henterPantMode]="true"></app-reviews>
  </div>
</section>

<section id="call-to-action">
  <div class="container">
    <app-call-to-action [henterPantMode]="true"></app-call-to-action>
  </div>
</section>

<section id="download">
  <div class="container">
    <app-download [henterPantMode]="true"></app-download>
  </div>
</section>

<section id="contact-form">
  <a id="contact-us" class="anchor"></a>
  <div class="container">
    <app-contact-form [henterPantMode]="true"></app-contact-form>
  </div>
</section>
